import pugBodyTemplate from './views/showTourBody.pug';
import pugHeadTemplate from './views/showTourHead.pug';
import { getTranslation } from './services/translations/getTranslations';

import {
  featureToggle,
  createFeatureDecisions,
} from './features';

class Loader3DEstate {
  constructor (config, templateBody = pugBodyTemplate, templateHead = pugHeadTemplate) {
    this.config = config;

    this.config.scriptDomain = APP_URI;
    if (!this.config.scriptDomain) {
      this.config.scriptDomain = location.origin; // dev env
    }

    if (!this.config.hideFullscreenBtn) {
      this.config.hideFullscreenBtn = false;
    }

    this.templateBody = templateBody;
    this.templateHead = templateHead;
  }

  loadView () {
    this.replaceDocumentContent();
  }

  replaceDocumentContent () {
    const { config, templateBody, templateHead } = this;

    document.head.innerHTML += templateHead(config);
    const scriptDomain = config.scriptDomain;

    const scripts = [
      scriptDomain + '/GASetup.js',
      'https://cdn.jsdelivr.net/gh/aframevr/aframe@cd01cec35a01e03eb2d6a9272500a53de31d3828/dist/aframe-master.min.js',
      scriptDomain + '/Components.bundle.js',
    ];

    function importScripts (scripts, callback) {
      if (scripts.length === 0) {
        if (callback !== undefined) {
          callback(null);
        }
      }
      var i = 0;
      var s;
      var r;
      var e;
      var l;
      e = function (event) {
        s.parentNode.removeChild(s);
        if (callback !== undefined) {
          callback(event);
        }
      };
      l = function () {
        s.parentNode.removeChild(s);
        i++;
        if (i < scripts.length) {
          r();
          return;
        }
        if (callback !== undefined) {
          callback(null);
        }
      };
      r = function () {
        s = document.createElement('script');
        s.src = scripts[i];
        s.onerror = e;
        s.onload = l;
        document.head.appendChild(s);
      };
      r();
    }

    importScripts(scripts, async function () {
      const translations = getTranslation();
      const featureDecisions = await createFeatureDecisions(featureToggle);

      document.body.style.opacity = 1;
      document.body.innerHTML = templateBody({
        ...config,
        translations,
        featureDecisions,
      });
    });
  }
}

window.Loader3DEstate = Loader3DEstate;
